import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect, useRef} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import { Search } from "@mui/icons-material";
import { IconButton} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

export default function DokumenPopUp({currPreview}){
    const checkttdKontrak = () => {
      console.log(currPreview)
      if (Array.isArray(currPreview.signatureKey)) {
        currPreview.signatureKey.forEach(filename => {
          console.log(filename)
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                responseType: 'blob' // Tell axios to get the response as a blob
            })
            .then((response) => {
              const contentType = response.headers['content-type'];
              console.log(response);
              console.log(response.headers)
              console.log(contentType)
              if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                const blob = new Blob([response.data], { type: contentType });
                const url = URL.createObjectURL(blob);
                window.open(url);
            } else {
                // For other file types, download the file
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                document.body.appendChild(link);
                link.click();
            }
            })
            .catch((error) => {
                console.log('Error fetching the file:', error);
            });
        });
    } else {
        // Handle case where currPreview.signatureKey is not an array
    }
    
    }

    const checkDokCompany = () =>{
      console.log(currPreview)
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/CompanyProfile?thisCompany=${currPreview.CompanyID}`, {
      }).then((response) => {
        const nibKey = response.data.data[0].nibKey?? "";
        const akteKey = response.data.data[0].akteKey?? "";
        const npwpKey = response.data.data[0].npwpKey?? "";
        console.log(response.data.data[0].npwpKey?? "NPWP Tidak ada Upload")
        console.log(response.data.data[0].akteKey?? "Akte Tidak ada Upload" )
        console.log(response.data.data[0].nibKey?? "NIB Tidak ada Upload")
        //NIB Key
        if(nibKey){
          if (Array.isArray(nibKey)) {
            nibKey.forEach(filename => {
              console.log(filename)
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                    responseType: 'blob' // Tell axios to get the response as a blob
                })
                .then((response) => {
                  const contentType = response.headers['content-type'];
                  console.log(response);
                  console.log(response.headers)
                  console.log(contentType)
                  if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                    // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                    const blob = new Blob([response.data], { type: contentType });
                    const url = URL.createObjectURL(blob);
                    window.open(url);
                } else {
                    // For other file types, download the file
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                    document.body.appendChild(link);
                    link.click();
                }
                })
                .catch((error) => {
                    console.log('Error fetching the file:', error);
                });
            });
        } else {
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${nibKey}`, {
            responseType: 'blob' // Tell axios to get the response as a blob
        })
        .then((response) => {
          const contentType = response.headers['content-type'];
          console.log(response);
          console.log(response.headers)
          console.log(contentType)
          if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
            // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
            const blob = new Blob([response.data], { type: contentType });
            const url = URL.createObjectURL(blob);
            window.open(url);
        } else {
            // For other file types, download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', 'file'); // Modify the filename and extension as needed
            document.body.appendChild(link);
            link.click();
        }
        })
        .catch((error) => {
            console.log('Error fetching the file:', error);
        });
        }
        }

              //NIB Key End
        //Akte Key
        if(akteKey){
          if (Array.isArray(akteKey)) {
            akteKey.forEach(filename => {
              console.log(filename)
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                    responseType: 'blob' // Tell axios to get the response as a blob
                })
                .then((response) => {
                  const contentType = response.headers['content-type'];
                  console.log(response);
                  console.log(response.headers)
                  console.log(contentType)
                  if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                    // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                    const blob = new Blob([response.data], { type: contentType });
                    const url = URL.createObjectURL(blob);
                    window.open(url);
                } else {
                    // For other file types, download the file
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                    document.body.appendChild(link);
                    link.click();
                }
                })
                .catch((error) => {
                    console.log('Error fetching the file:', error);
                });
            });
        } else {
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${akteKey}`, {
            responseType: 'blob' // Tell axios to get the response as a blob
        })
        .then((response) => {
          const contentType = response.headers['content-type'];
          console.log(response);
          console.log(response.headers)
          console.log(contentType)
          if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
            // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
            const blob = new Blob([response.data], { type: contentType });
            const url = URL.createObjectURL(blob);
            window.open(url);
        } else {
            // For other file types, download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', 'file'); // Modify the filename and extension as needed
            document.body.appendChild(link);
            link.click();
        }
        })
        .catch((error) => {
            console.log('Error fetching the file:', error);
        });
        }
        }

              //Akte Key End

              //Akte Key
        if(npwpKey){
          if (Array.isArray(npwpKey)) {
            npwpKey.forEach(filename => {
              console.log(filename)
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                    responseType: 'blob' // Tell axios to get the response as a blob
                })
                .then((response) => {
                  const contentType = response.headers['content-type'];
                  console.log(response);
                  console.log(response.headers)
                  console.log(contentType)
                  if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                    // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                    const blob = new Blob([response.data], { type: contentType });
                    const url = URL.createObjectURL(blob);
                    window.open(url);
                } else {
                    // For other file types, download the file
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                    document.body.appendChild(link);
                    link.click();
                }
                })
                .catch((error) => {
                    console.log('Error fetching the file:', error);
                });
            });
        } else {
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${npwpKey}`, {
            responseType: 'blob' // Tell axios to get the response as a blob
        })
        .then((response) => {
          const contentType = response.headers['content-type'];
          console.log(response);
          console.log(response.headers)
          console.log(contentType)
          if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
            // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
            const blob = new Blob([response.data], { type: contentType });
            const url = URL.createObjectURL(blob);
            window.open(url);
        } else {
            // For other file types, download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', 'file'); // Modify the filename and extension as needed
            document.body.appendChild(link);
            link.click();
        }
        })
        .catch((error) => {
            console.log('Error fetching the file:', error);
        });
        }
        }

              //NPWP Key End
      })
      .catch((error) => {
        console.error('There was an error!', error);
      });


      

      

    }



    const checkDokKlien = () =>{
      console.log(currPreview)
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/KlienProfile?thisClient=${currPreview.KlienID}`, {
      }).then((response) => {
        const ktpKey = response.data.data[0].ktpKey?? "";
        const npwpKey = response.data.data[0].npwpKey?? "";
        console.log(response.data.data[0].npwpKey?? "NPWP Tidak ada Upload")
        console.log(response.data.data[0].ktpKey?? "KTP Tidak ada Upload" )
        //KTP Key
        if(ktpKey){
          if (Array.isArray(ktpKey)) {
            ktpKey.forEach(filename => {
              console.log(filename)
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                    responseType: 'blob' // Tell axios to get the response as a blob
                })
                .then((response) => {
                  const contentType = response.headers['content-type'];
                  console.log(response);
                  console.log(response.headers)
                  console.log(contentType)
                  if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                    // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                    const blob = new Blob([response.data], { type: contentType });
                    const url = URL.createObjectURL(blob);
                    window.open(url);
                } else {
                    // For other file types, download the file
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                    document.body.appendChild(link);
                    link.click();
                }
                })
                .catch((error) => {
                    console.log('Error fetching the file:', error);
                });
            });
        } else {
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${ktpKey}`, {
            responseType: 'blob' // Tell axios to get the response as a blob
        })
        .then((response) => {
          const contentType = response.headers['content-type'];
          console.log(response);
          console.log(response.headers)
          console.log(contentType)
          if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
            // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
            const blob = new Blob([response.data], { type: contentType });
            const url = URL.createObjectURL(blob);
            window.open(url);
        } else {
            // For other file types, download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', 'file'); // Modify the filename and extension as needed
            document.body.appendChild(link);
            link.click();
        }
        })
        .catch((error) => {
            console.log('Error fetching the file:', error);
        });
        }
        }

              //KTP Key End
      
              //NPWP Key
        if(npwpKey){
          if (Array.isArray(npwpKey)) {
            npwpKey.forEach(filename => {
              console.log(filename)
                axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${filename}`, {
                    responseType: 'blob' // Tell axios to get the response as a blob
                })
                .then((response) => {
                  const contentType = response.headers['content-type'];
                  console.log(response);
                  console.log(response.headers)
                  console.log(contentType)
                  if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf', 'image/webp', 'image/jpg'].includes(contentType)) {
                    // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
                    const blob = new Blob([response.data], { type: contentType });
                    const url = URL.createObjectURL(blob);
                    window.open(url);
                } else {
                    // For other file types, download the file
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(new Blob([response.data]));
                    link.setAttribute('download', 'file'); // Modify the filename and extension as needed
                    document.body.appendChild(link);
                    link.click();
                }
                })
                .catch((error) => {
                    console.log('Error fetching the file:', error);
                });
            });
        } else {
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${npwpKey}`, {
            responseType: 'blob' // Tell axios to get the response as a blob
        })
        .then((response) => {
          const contentType = response.headers['content-type'];
          console.log(response);
          console.log(response.headers)
          console.log(contentType)
          if (['image/png', 'image/jpeg', 'image/gif', 'application/pdf'].includes(contentType)) {
            // If it's a PNG, JPEG, GIF or PDF, open it in a new browser tab
            const blob = new Blob([response.data], { type: contentType });
            const url = URL.createObjectURL(blob);
            window.open(url);
        } else {
            // For other file types, download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', 'file'); // Modify the filename and extension as needed
            document.body.appendChild(link);
            link.click();
        }
        })
        .catch((error) => {
            console.log('Error fetching the file:', error);
        });
        }
        }

              //NPWP Key End
      })
      .catch((error) => {
        console.error('There was an error!', error);
      });


      

      

    }
    return <Grid sx={{m:2}}>
    <Grid xs={12}>
        <Button variant="contained" onClick={checkDokKlien}>Cek KTP dan NPWP Klien</Button>
    </Grid>
    <Grid xs={12}>
        <Button variant="contained" onClick={checkDokCompany}>Cek Dokumen Perusahaan</Button>
    </Grid>
    <Grid xs={12}>
        <Button variant="contained" onClick={checkttdKontrak}>Cek TTD Kontrak</Button>
    </Grid>

    </Grid>
}